<!-- Hero -->
<section class="cuspage-hero">
  <div class="cuspage-hero__bg"></div>
  <div class="container">
    <div class="cuspage-hero__content">
      <h1 class="cuspage-hero__title">{{ 'pay_hero_title' | translate }}</h1>
      <p class="cuspage-hero__sub">{{ 'pay_hero_sub' | translate }}</p>
    </div>
  </div>
</section>

<!-- Main section -->
<section class="pay-section">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-xl-6 col-lg-7 col-md-10">

        <!-- Progress bar -->
        <div class="pay-steps" *ngIf="step < 5">
          <div class="pay-step" [class.active]="step >= 1" [class.done]="step > 1">
            <div class="pay-step__dot"><span>1</span></div>
            <span class="pay-step__label">{{ 'pay_step_ref' | translate }}</span>
          </div>
          <div class="pay-step__line" [class.done]="step > 1"></div>
          <div class="pay-step" [class.active]="step >= 2" [class.done]="step > 2">
            <div class="pay-step__dot"><span>2</span></div>
            <span class="pay-step__label">{{ 'pay_step_details' | translate }}</span>
          </div>
          <div class="pay-step__line" [class.done]="step > 2"></div>
          <div class="pay-step" [class.active]="step >= 3" [class.done]="step > 3">
            <div class="pay-step__dot"><span>3</span></div>
            <span class="pay-step__label">{{ 'pay_step_login' | translate }}</span>
          </div>
          <div class="pay-step__line" [class.done]="step > 3"></div>
          <div class="pay-step" [class.active]="step >= 4" [class.done]="step > 4">
            <div class="pay-step__dot"><span>4</span></div>
            <span class="pay-step__label">{{ 'pay_step_payment' | translate }}</span>
          </div>
        </div>

        <!-- ── STEP 1 : Saisir la référence ───────────────────────────────── -->
        <div *ngIf="step === 1" class="pay-card wow fadeInUp">
          <div class="pay-card__header">
            <div class="pay-card__icon pay-card__icon--blue">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
                <circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35" stroke-linecap="round"/>
              </svg>
            </div>
            <div>
              <h3 class="pay-card__title">{{ 'pay_search_title' | translate }}</h3>
              <p class="pay-card__sub">{{ 'pay_search_sub' | translate }}</p>
            </div>
          </div>

          <div class="pay-ref-input-wrap">
            <input
              type="text"
              class="pay-ref-input"
              [(ngModel)]="reference"
              [placeholder]="'pay_ref_ph' | translate"
              (keyup.enter)="search()"
              autocomplete="off"
              spellcheck="false">
          </div>

          <div *ngIf="lookupError" class="pay-alert pay-alert--error">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
            </svg>
            {{ lookupError }}
          </div>

          <div class="pay-hints">
            <p><strong>{{ 'pay_formats' | translate }}</strong></p>
            <ul>
              <li><code>ARP-XXX-2026-0001</code> — {{ 'pay_format_app' | translate }}</li>
              <li><code>INF-2026-00001</code> — {{ 'pay_format_inf' | translate }}</li>
            </ul>
          </div>

          <button class="careox-btn pay-btn-full" (click)="search()" [disabled]="lookupLoading || !reference.trim()">
            <span *ngIf="lookupLoading" class="arp-spinner"></span>
            <span>{{ (lookupLoading ? 'pay_searching' : 'pay_search_btn') | translate }}</span>
          </button>
        </div>

        <!-- ── STEP 2 : Détails du dossier ───────────────────────────────── -->
        <div *ngIf="step === 2 && lookup" class="pay-card wow fadeInUp">
          <div class="pay-card__header">
            <div class="pay-card__icon" [class.pay-card__icon--orange]="lookup.type === 'infraction'" [class.pay-card__icon--blue]="lookup.type === 'application'">
              <i [class]="typeIcon()" style="font-size:20px;"></i>
            </div>
            <div>
              <h3 class="pay-card__title">{{ lookup.title }}</h3>
              <p class="pay-card__sub" *ngIf="lookup.subtitle">{{ lookup.subtitle }}</p>
            </div>
          </div>

          <div class="pay-detail-grid">
            <div class="pay-detail-item">
              <span class="pay-detail-item__label">{{ 'pay_step_ref' | translate }}</span>
              <span class="pay-detail-item__value pay-ref-badge">{{ lookup.reference }}</span>
            </div>
            <div class="pay-detail-item">
              <span class="pay-detail-item__label">{{ 'pay_holder' | translate }}</span>
              <span class="pay-detail-item__value">{{ lookup.holder }}</span>
            </div>
            <div class="pay-detail-item">
              <span class="pay-detail-item__label">{{ 'pay_status' | translate }}</span>
              <span [class]="statusClass(lookup.status)">{{ lookup.status_label }}</span>
            </div>
            <div class="pay-detail-item" *ngIf="lookup.authorized_amount > 0">
              <span class="pay-detail-item__label">{{ 'pay_total' | translate }}</span>
              <span class="pay-detail-item__value">{{ formatAmount(lookup.authorized_amount) }}</span>
            </div>
            <div class="pay-detail-item" *ngIf="lookup.paid_amount > 0">
              <span class="pay-detail-item__label">{{ 'pay_already_paid' | translate }}</span>
              <span class="pay-detail-item__value pay-detail-item__value--green">{{ formatAmount(lookup.paid_amount) }}</span>
            </div>
          </div>

          <!-- Amount due banner -->
          <div class="pay-amount-banner" *ngIf="lookup.can_pay">
            <span class="pay-amount-banner__label">{{ 'pay_amount_due' | translate }}</span>
            <span class="pay-amount-banner__amount">{{ formatAmount(lookup.amount_due) }}</span>
          </div>

          <!-- Cannot pay — warning but still allow auth -->
          <div class="pay-alert pay-alert--warn" *ngIf="!lookup.can_pay">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
              <line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/>
            </svg>
            <span>{{ 'pay_not_pending_warn' | translate:{ status: lookup.status_label } }}</span>
          </div>

          <div class="pay-actions">
            <button class="careox-btn careox-btn--ghost" (click)="step = 1">
              <span>← {{ 'pay_back' | translate }}</span>
            </button>
            <button class="careox-btn" (click)="proceedToAuth()">
              <span>{{ (lookup.can_pay ? 'pay_continue' : 'pay_login_arrow') | translate }} →</span>
            </button>
          </div>
        </div>

        <!-- ── STEP 3 : Authentification ─────────────────────────────────── -->
        <div *ngIf="step === 3" class="pay-card wow fadeInUp">

          <!-- Header -->
          <div class="pay-card__header">
            <div class="pay-card__icon pay-card__icon--green">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
                <rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/>
              </svg>
            </div>
            <div>
              <h3 class="pay-card__title">{{ 'pay_id_title' | translate }}</h3>
              <p class="pay-card__sub">{{ 'pay_id_sub' | translate }}</p>
            </div>
          </div>

          <!-- Tab toggle -->
          <div class="pay-auth-tabs">
            <button
              class="pay-auth-tab"
              [class.active]="authMode === 'login'"
              (click)="switchAuthMode('login')">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
                <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"/>
                <polyline points="10 17 15 12 10 7"/>
                <line x1="15" y1="12" x2="3" y2="12"/>
              </svg>
              {{ 'pay_login_tab' | translate }}
            </button>
            <button
              class="pay-auth-tab"
              [class.active]="authMode === 'register'"
              (click)="switchAuthMode('register')">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/>
                <circle cx="9" cy="7" r="4"/>
                <line x1="19" y1="8" x2="19" y2="14"/>
                <line x1="22" y1="11" x2="16" y2="11"/>
              </svg>
              {{ 'pay_register_tab' | translate }}
            </button>
          </div>

          <!-- ── Login form ── -->
          <div *ngIf="authMode === 'login'" class="pay-login-form">
            <div class="pay-field">
              <label class="pay-label">{{ 'pay_email' | translate }}</label>
              <input
                type="email"
                class="pay-input"
                [(ngModel)]="loginEmail"
                [placeholder]="'pay_email_ph' | translate"
                autocomplete="email"
                (keyup.enter)="login()">
            </div>
            <div class="pay-field">
              <label class="pay-label">{{ 'pay_password' | translate }}</label>
              <div class="pay-input-wrap">
                <input
                  [type]="showPassword ? 'text' : 'password'"
                  class="pay-input"
                  [(ngModel)]="loginPassword"
                  placeholder="••••••••"
                  autocomplete="current-password"
                  (keyup.enter)="login()">
                <button type="button" class="pay-eye-btn" (click)="showPassword = !showPassword">
                  <svg *ngIf="!showPassword" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                    <circle cx="12" cy="12" r="3"/>
                  </svg>
                  <svg *ngIf="showPassword" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
                    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/>
                    <line x1="1" y1="1" x2="23" y2="23"/>
                  </svg>
                </button>
              </div>
            </div>

            <div *ngIf="loginError" class="pay-alert pay-alert--error">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
              </svg>
              {{ loginError }}
            </div>

            <div class="pay-actions">
              <button class="careox-btn careox-btn--ghost" (click)="step = 2">
                <span>← {{ 'pay_back' | translate }}</span>
              </button>
              <button
                class="careox-btn"
                (click)="login()"
                [disabled]="loginLoading || !loginEmail || !loginPassword">
                <span *ngIf="loginLoading" class="arp-spinner"></span>
                <span>{{ (loginLoading ? 'pay_logging' : 'pay_login_arrow') | translate }}</span>
              </button>
            </div>
          </div>

          <!-- ── Register form ── -->
          <div *ngIf="authMode === 'register'" class="pay-login-form">
            <div class="pay-field">
              <label class="pay-label">{{ 'pay_name' | translate }} <span class="pay-required">*</span></label>
              <input
                type="text"
                class="pay-input"
                [(ngModel)]="regName"
                [placeholder]="'pay_name_ph' | translate"
                autocomplete="name">
            </div>
            <div class="pay-field">
              <label class="pay-label">{{ 'pay_email' | translate }} <span class="pay-required">*</span></label>
              <input
                type="email"
                class="pay-input"
                [(ngModel)]="regEmail"
                [placeholder]="'pay_email_ph' | translate"
                autocomplete="email">
            </div>
            <div class="pay-field">
              <label class="pay-label">{{ 'pay_password' | translate }} <span class="pay-required">*</span></label>
              <div class="pay-input-wrap">
                <input
                  [type]="showRegPwd ? 'text' : 'password'"
                  class="pay-input"
                  [(ngModel)]="regPassword"
                  [placeholder]="'pay_pwd_ph' | translate"
                  autocomplete="new-password">
                <button type="button" class="pay-eye-btn" (click)="showRegPwd = !showRegPwd">
                  <svg *ngIf="!showRegPwd" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                    <circle cx="12" cy="12" r="3"/>
                  </svg>
                  <svg *ngIf="showRegPwd" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
                    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/>
                    <line x1="1" y1="1" x2="23" y2="23"/>
                  </svg>
                </button>
              </div>
            </div>
            <div class="pay-field">
              <label class="pay-label">{{ 'pay_confirm_pwd' | translate }} <span class="pay-required">*</span></label>
              <input
                type="password"
                class="pay-input"
                [(ngModel)]="regConfirm"
                [placeholder]="'pay_confirm_ph' | translate"
                autocomplete="new-password"
                (keyup.enter)="register()">
              <!-- strength bar -->
              <div class="pay-pwd-bar" *ngIf="regPassword.length > 0">
                <div class="pay-pwd-bar__fill"
                  [style.width]="(regPassword.length >= 10 ? 100 : regPassword.length >= 6 ? 60 : 30) + '%'"
                  [class.weak]="regPassword.length < 6"
                  [class.medium]="regPassword.length >= 6 && regPassword.length < 10"
                  [class.strong]="regPassword.length >= 10">
                </div>
                <span class="pay-pwd-bar__label">
                  {{ (regPassword.length < 6 ? 'pay_pwd_weak' : regPassword.length < 10 ? 'pay_pwd_medium' : 'pay_pwd_strong') | translate }}
                </span>
              </div>
            </div>

            <div *ngIf="regError" class="pay-alert pay-alert--error">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
              </svg>
              {{ regError }}
            </div>

            <div class="pay-actions">
              <button class="careox-btn careox-btn--ghost" (click)="step = 2">
                <span>← {{ 'pay_back' | translate }}</span>
              </button>
              <button
                class="careox-btn"
                (click)="register()"
                [disabled]="regLoading || !regName || !regEmail || !regPassword || !regConfirm">
                <span *ngIf="regLoading" class="arp-spinner"></span>
                <span>{{ (regLoading ? 'pay_creating' : 'pay_create_account') | translate }}</span>
              </button>
            </div>
          </div>

        </div>

        <!-- ── STEP 4 : Formulaire de paiement ───────────────────────────── -->
        <div *ngIf="step === 4" class="pay-card wow fadeInUp">
          <!-- Connected user banner -->
          <div class="pay-user-banner" *ngIf="authUser">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/>
            </svg>
            <span>{{ 'pay_connected_as' | translate }} <strong>{{ authUser.name }}</strong></span>
            <button class="pay-logout-btn" (click)="logout()">{{ 'pay_change' | translate }}</button>
          </div>

          <div class="pay-card__header">
            <div class="pay-card__icon" [class.pay-card__icon--orange]="lookup?.can_pay" [class.pay-card__icon--gray]="!lookup?.can_pay">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
                <rect x="1" y="4" width="22" height="16" rx="2" ry="2"/>
                <line x1="1" y1="10" x2="23" y2="10"/>
              </svg>
            </div>
            <div>
              <h3 class="pay-card__title">{{ (lookup?.can_pay ? 'pay_do_payment' : 'pay_not_payable') | translate }}</h3>
              <p class="pay-card__sub" *ngIf="lookup">{{ 'pay_reference_word' | translate }} {{ lookup.reference }}<ng-container *ngIf="lookup.can_pay"> — <strong>{{ formatAmount(lookup.amount_due) }}</strong></ng-container></p>
            </div>
          </div>

          <!-- Not payable — informational block -->
          <div *ngIf="!lookup?.can_pay" class="pay-alert pay-alert--warn">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
              <line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/>
            </svg>
            <span>{{ 'pay_not_pending_warn2' | translate:{ status: lookup?.status_label } }}</span>
          </div>

          <!-- Payable — payment form -->
          <ng-container *ngIf="lookup?.can_pay">

          <!-- Method selection -->
          <div class="pay-field">
            <label class="pay-label">{{ 'pay_method' | translate }} <span class="pay-required">*</span></label>
            <div class="pay-methods">
              <label
                *ngFor="let m of methods"
                class="pay-method"
                [class.selected]="payMethod === m.value">
                <input type="radio" name="payMethod" [value]="m.value" [(ngModel)]="payMethod" hidden>
                <span class="pay-method__icon"><i [class]="m.icon"></i></span>
                <span class="pay-method__label">{{ m.label | translate }}</span>
                <span class="pay-method__check"><i class="fa-solid fa-check"></i></span>
              </label>
            </div>
          </div>

          <!-- Transaction reference (optional) -->
          <div class="pay-field">
            <label class="pay-label">{{ 'pay_txn_ref' | translate }} <span class="pay-opt">{{ 'commun_facultatif' | translate }}</span></label>
            <input
              type="text"
              class="pay-input"
              [(ngModel)]="payRef"
              [placeholder]="'pay_txn_ref_ph' | translate">
            <span class="pay-hint">{{ 'pay_txn_hint' | translate }}</span>
          </div>

          <div *ngIf="payError" class="pay-alert pay-alert--error">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
            </svg>
            {{ payError }}
          </div>

          <div class="pay-summary-bar" *ngIf="lookup">
            <span>{{ 'pay_amount_due' | translate }}</span>
            <strong>{{ formatAmount(lookup.amount_due) }}</strong>
          </div>

          </ng-container>

          <div class="pay-actions">
            <button class="careox-btn careox-btn--ghost" (click)="step = 2">
              <span>← {{ 'pay_back' | translate }}</span>
            </button>
            <button
              *ngIf="lookup?.can_pay"
              class="careox-btn pay-btn-submit"
              (click)="confirmPayment()"
              [disabled]="payLoading || !payMethod">
              <span *ngIf="payLoading" class="arp-spinner"></span>
              <span>{{ payLoading ? ('pay_processing' | translate) : (('pay_pay_btn' | translate) + ' ' + (lookup ? formatAmount(lookup.amount_due) : '')) }}</span>
            </button>
          </div>
        </div>

        <!-- ── STEP 5 : Confirmation ──────────────────────────────────────── -->
        <div *ngIf="step === 5 && result" class="pay-card pay-card--success wow fadeInUp">
          <div class="pay-success-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
              <polyline points="22 4 12 14.01 9 11.01"/>
            </svg>
          </div>
          <h3 class="pay-success-title">{{ 'pay_success_title' | translate }}</h3>
          <p class="pay-success-sub">{{ result.message }}</p>

          <div class="pay-receipt">
            <div class="pay-receipt__row">
              <span>{{ 'pay_receipt_number' | translate }}</span>
              <strong class="pay-ref-badge">{{ result.payment_number }}</strong>
            </div>
            <div class="pay-receipt__row">
              <span>{{ 'pay_amount_word' | translate }}</span>
              <strong>{{ formatAmount(result.amount) }}</strong>
            </div>
            <div class="pay-receipt__row">
              <span>{{ 'pay_method' | translate }}</span>
              <strong>{{ methodLabel(result.method) | translate }}</strong>
            </div>
            <div class="pay-receipt__row">
              <span>{{ 'pay_status' | translate }}</span>
              <span class="pay-status pay-status--warn">{{ 'pay_pending_verif' | translate }}</span>
            </div>
          </div>

          <div class="pay-success-note">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
              <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
            </svg>
            <p>{{ 'pay_success_note' | translate }}</p>
          </div>

          <div class="text-center mt-4">
            <button class="careox-btn" (click)="reset()">
              <span>{{ 'pay_new' | translate }}</span>
            </button>
          </div>
        </div>

      </div>
    </div>
  </div>
</section>
